var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListOfToolsPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 101,
    viewBox: "0 0 125 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105 100.7L20.0003 100.7C9.12033 100.7 0.300361 91.88 0.30036 81L0.300356 15.0429L124.7 15.0429L124.7 81C124.7 91.88 115.88 100.7 105 100.7Z",
    fill: "white",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.438 41.1484H80.8589C82.8659 41.1484 84.5 42.782 84.4999 44.7924C84.4999 46.7996 82.866 48.4335 80.8588 48.4335H55.438C53.4307 48.4335 51.7968 46.7996 51.7968 44.7924C51.7968 42.7821 53.431 41.1484 55.438 41.1484Z",
    fill: "#EBF2F9",
    stroke: "#D2DBE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 44.791C40.5 42.783 42.1346 41.1484 44.1426 41.1484C46.1507 41.1484 47.7852 42.7829 47.7852 44.791C47.7852 46.799 46.1507 48.4335 44.1426 48.4335C42.1346 48.4335 40.5 46.799 40.5 44.791Z",
    fill: "#EBF2F9",
    stroke: "#D2DBE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 57.5C40.5 55.4919 42.1346 53.8574 44.1426 53.8574C46.1507 53.8574 47.7852 55.4919 47.7852 57.5C47.7852 59.508 46.1507 61.1425 44.1426 61.1425C42.1346 61.1425 40.5 59.508 40.5 57.5Z",
    fill: "#EBF2F9",
    stroke: "#D2DBE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 70.209C40.5 68.2009 42.1346 66.5664 44.1426 66.5664C46.1507 66.5664 47.7852 68.2009 47.7852 70.209C47.7852 72.217 46.1507 73.8515 44.1426 73.8515C42.1346 73.8515 40.5 72.217 40.5 70.209Z",
    fill: "#EBF2F9",
    stroke: "#D2DBE2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.438 53.8574H80.8589C82.8659 53.8574 84.5 55.491 84.4999 57.5014C84.4999 59.5086 82.866 61.1425 80.8588 61.1425H55.438C53.4307 61.1425 51.7968 59.5086 51.7968 57.5014C51.7968 55.4911 53.431 53.8574 55.438 53.8574Z",
    fill: "#EBF2F9",
    stroke: "#D2DBE2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.438 66.5664H80.8589C82.8659 66.5664 84.5 68.2001 84.4999 70.2103C84.4999 72.2176 82.866 73.8515 80.8588 73.8515H55.438C53.4307 73.8515 51.7968 72.2176 51.7968 70.2104C51.7968 68.2001 53.431 66.5664 55.438 66.5664Z",
    fill: "#EBF2F9",
    stroke: "#D2DBE2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0818 0.3L108.918 0.3C117.534 0.3 124.537 7.20421 124.697 15.7818L0.302794 15.7818C0.462709 7.20421 7.46598 0.3 16.0818 0.3Z",
    fill: "#EBF2F9",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9649,
    cy: 8.04088,
    r: 1.89298,
    fill: "#EBF2F9",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.2748,
    cy: 8.04088,
    r: 1.89298,
    fill: "#EBF2F9",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5847,
    cy: 8.04088,
    r: 1.89298,
    fill: "#EBF2F9",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListOfToolsPlaceholder);
export default __webpack_public_path__ + "static/media/list-of-tools-placeholder.02c8bd44458e882e103072e479b2d17c.svg";
export { ForwardRef as ReactComponent };